import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable, { TableBody } from "mui-datatables";
import { Box, Rating, TableCell, Tooltip, Typography } from '@mui/material';
import { Chip } from '@mui/material';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faEdit, faPlay, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';
import UserContext from '../../../navigation/context/userContext';
import { GetProductos } from '../../../controllers/company/ProductsController';
import CompanyRoutes from '../../../apiRoutes/CompanyRoutes';
import { imagesURL } from '../../../apiRoutes/apiBase';
import { POST } from '../../../controllers/ConsumeApiController';
import { useTranslation } from 'react-i18next';
import { Table } from '@mui/material';
import { TableRow } from '@mui/material';
import { Grid } from '@mui/material';
import { Divider } from '@mui/material';

//export default class TablaProductos extends Component
export default function ReviewsDataTable(props)
{
    const {t, i18n} = useTranslation();

    const {userData,setUserData} = useContext(UserContext)
    const [reviews,setReviews] = useState(props.reviews);

    const columns = [
        {
            name : 'score',
            label : `${t('reviews.score')}`,
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        <Box>
                            <Rating value={reviews[dataIndex].score}/>
                        </Box>
                    );
                },
                filter:false,
                searchable:true
            }
        },
        {
            name:'type',
            label:`${t('reviews.type')}`,
        },
        {
            name : 'comment',
            label : `${t('reviews.comment')}`,
            
            options:{
                filter:false,
                searchable:true
            }
        },
        {
            name : 'created_at',
            label : `${t('reviews.date')}`,
            
            options:{
                filter:false,
                searchable:true
            }
        }
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
        // --- Opciones para expandir filas ---
        expandableRows: true, // Habilita la funcionalidad de expandir filas
        expandableRowsHeader: true, // Muestra una columna de encabezado para el botón de expansión
        expandableRowsOnClick: false, // Por defecto, se expande haciendo clic en el ícono. Si lo pones en true, cualquier clic en la fila la expande.
        
        renderExpandableRow: (rowData, rowMeta) => {
            // rowData: ['Joe James', 'Test Corp', 'Yonkers', 'NY']
            // rowMeta: { dataIndex: 0, rowIndex: 0 }
            console.log('Expandable row data ===> ',rowMeta);
            console.log('Row Data ===> ',reviews[rowMeta.dataIndex]);
            //const colSpan = rowData.length + 1; // +1 porque MUIDataTable añade una columna extra para el botón de expansión
            let index = rowMeta.dataIndex;
            const colSpan = rowData.length + 1;
            // Accede a los datos originales de la fila usando dataIndex
            //const originalRowData = rowData[rowMeta.dataIndex]; 

            return (
                <tr key={`expanded-row-${index}`}>
                    <td colSpan={colSpan}>
                        <Box 
                            sx={{ 
                                margin: 1, 
                                padding: 2, 
                                border: '1px solid #f1f1f1', 
                                borderRadius: '4px', 
                                //backgroundColor: '#f2f2f2' 
                                backgroundColor: '#f5fbff',
                            }}
                        >
                            <Grid container spacing={3}>
                                <Grid item md={6} lg={6}>
                                    <Typography variant='body1' fontWeight={'bold'}>Datos del Cliente</Typography>
                                    <Divider/>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Nombre:</span> {`${reviews[index].reviewer.name}`} </Typography>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Apellido:</span> {`${reviews[index].reviewer.last_name}`} </Typography>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Telefono:</span> {`${reviews[index].reviewer.phone}`} </Typography>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Correo:</span> {`${reviews[index].reviewer.email}`} </Typography>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Tipo:</span> {`${reviews[index].reviewer.type}`} </Typography>
                                </Grid>
                                <Grid item lg={6}>
                                    <Typography variant='body1' fontWeight={'bold'}>Datos de la Reseña</Typography>
                                    <Divider/>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- ID:</span> {`${reviews[index].id}`} </Typography>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Tipo:</span> {`${reviews[index].type}`} </Typography>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Puntuación:</span> {`${reviews[index].score}`} </Typography>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Comentario:</span> {`${reviews[index].comment}`} </Typography>
                                    <Typography variant='body1'><span style={{fontWeight:'bold'}}>- Fecha:</span> {`${reviews[index].created_at}`} </Typography>
                                    {
                                        reviews[index].type === 'product' &&
                                        <Typography variant='body1'>Ver: <a href='hola'>Producto</a> </Typography>
                                    }
                                    
                                </Grid>
                            </Grid>
                        </Box>
                    </td>
                </tr>
            );
        },

        elevation: 1
    };


    return(
        <MUIDataTable
            title={`${t('reviews.list')}`}
            data={reviews}
            columns={columns}
            options={options}
        />
    )
}